/*!
 * cookie-gdpr.js v1.0.0.beta.2
 * (c) 2024 Klonbits, Inc.
 * All rights reserved.
 */

//#region Cookie names
const GDPR_MODAL_ID = "#gdprModal"
const GDPR_ALERT = "GDPR_ALERT"
const GDPR_PERM = "GDPR_PERM"
//#endregion Cookie names

//#region Check cookies ::: Check is GDPR_ALERT showed?
if (Cookies.get(GDPR_ALERT) !== '1') {
 console.debug(GDPR_ALERT, Cookies.get(GDPR_PERM), Cookies.get(GDPR_ALERT))
 // Set default values for `GDPR_ALERT` & `GDPR_PERM` cookie
 Cookies.set(GDPR_ALERT, 0)
 Cookies.set(GDPR_PERM, 0)
 // Show modal
 $(GDPR_MODAL_ID).addClass("show")

 //
 console.debug(GDPR_ALERT, Cookies.get(GDPR_PERM), Cookies.get(GDPR_ALERT))
}
//#endregion Check cookies ::: Check is GDPR_ALERT showed?

//#region Set cookies
function setGDPRPreferences(gdprPermPreferences = 0) {
 // Set Preferences
 Cookies.set(GDPR_ALERT, 1)
 Cookies.set(GDPR_PERM, gdprPermPreferences)

 // Hide modal
 $(GDPR_MODAL_ID).removeClass("show")
}
//#endregion Set cookies
